import React from "react";
import QRCode from "qrcode.react";

const QR = ({ url, bgColor, size, width, height }) => (
  <QRCode bgColor={bgColor} value={url} size={size} imageSettings={{ height, width }} />
)

export default QR